<template>
  <el-dialog :visible.sync="DingResultVisible" custom-class="dialogPaddingTop0">
    <p>同步成功部门{{DingResult.DEPT_ADD_SUCCESS}}个，失败{{DingResult.DEPT_ADD_FAIL}}个。</p>
    <p>同步成功用户{{DingResult.USER_ADD_SUCCESS}}个，失败{{DingResult.USER_ADD_FAIL}}个。</p>
    <el-table :data="DingResult.ERRORS" height="300px">
      <el-table-column
        prop="NAME"
        label="名字"
        width="120">
      </el-table-column>
      <el-table-column
        prop="ERROR"
        label="错误信息"
        width="180">
      </el-table-column>
      <el-table-column
        prop="TIP"
        label="错误提示">
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  created() {
  },
  
  computed: {
    DingResultVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  props: ['visible',"DingResult"],
  data() {
    return {

    };
  },
  methods: {
  }
};
</script>

<style>
</style>